import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd-mobile/es/global';
// import VConsole from 'vconsole';
import { configure } from 'mobx';

import './index.module.scss';

import App from '@shared/App';
import reportWebVitals from './reportWebVitals';
import { queryURL } from './utils';

configure({
    enforceActions: 'never'
});

document.title = queryURL('pageTitle') || '双录意愿核验';
// if (queryURL('isDebug') === 'true') {
// new VConsole();
// }

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
